<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content row">
      <div class="header-title-admin col-lg-10">{{'' | i18n: 'disclaimer-config'}}</div>
      <div class = "col-lg-2 btn-update">
        <button (click)="updateDisclaimers()">{{'' | i18n: 'save'}}</button>
      </div>
      <div class="filter-container col-lg-12 mt-3">
        <table>
          <tr>
            <td>
              <label>{{getLang(english?.lang)}}
                @if (english) {
                  <textarea type="text" [(ngModel)]="english.text" style="width: 300px; height: 200px"></textarea>
                }
              </label>
            </td>
            <td>
              <label>{{getLang(german?.lang)}}
                @if (german) {
                  <textarea type="text" [(ngModel)]="german.text" style="width: 300px; height: 200px"></textarea>
                }
              </label>
            </td>
            <td>
              <label style="margin-right: 16px;">{{getLang(french?.lang)}}
                @if (french) {
                  <textarea type="text" [(ngModel)]="french.text" style="width: 300px; height: 200px"></textarea>
                }
              </label>
            </td>
            <td>
              <label>{{getLang(dutch?.lang)}}
                @if (dutch) {
                  <textarea type="text" [(ngModel)]="dutch.text" style="width: 300px; height: 200px"></textarea>
                }
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
